import {
  LIST_EXAMINATION_ITEM_REQUEST,
  LIST_EXAMINATION_ITEM_SUCCESS,
  LIST_EXAMINATION_ITEM_FAIL,
  LIST_EXAMINATION_ITEM_RESET,
  SUMMARY_EXAMINATION_ITEM_REQUEST,
  SUMMARY_EXAMINATION_ITEM_SUCCESS,
  SUMMARY_EXAMINATION_ITEM_FAIL,
  POSITION_EXAMINATION_ITEM_REQUEST,
  POSITION_EXAMINATION_ITEM_SUCCESS,
  POSITION_EXAMINATION_ITEM_FAIL,
  CREATE_EXAMINATION_ITEM_REQUEST,
  CREATE_EXAMINATION_ITEM_SUCCESS,
  CREATE_EXAMINATION_ITEM_FAIL,
  DETAIL_EXAMINATION_ITEM_REQUEST,
  DETAIL_EXAMINATION_ITEM_SUCCESS,
  DETAIL_EXAMINATION_ITEM_FAIL,
  UPDATE_EXAMINATION_ITEM_REQUEST,
  UPDATE_EXAMINATION_ITEM_SUCCESS,
  UPDATE_EXAMINATION_ITEM_FAIL,
  DELETE_EXAMINATION_ITEM_REQUEST,
  DELETE_EXAMINATION_ITEM_SUCCESS,
  DELETE_EXAMINATION_ITEM_FAIL,
  LIST_KIT_VERSION_REQUEST,
  LIST_KIT_VERSION_SUCCESS,
  LIST_KIT_VERSION_FAIL,
  CREATE_KIT_VERSION_REQUEST,
  CREATE_KIT_VERSION_SUCCESS,
  CREATE_KIT_VERSION_FAIL,
  DETAIL_KIT_VERSION_REQUEST,
  DETAIL_KIT_VERSION_SUCCESS,
  DETAIL_KIT_VERSION_FAIL,
  UPDATE_KIT_VERSION_REQUEST,
  UPDATE_KIT_VERSION_SUCCESS,
  UPDATE_KIT_VERSION_FAIL,
  UPDATE_KIT_VERSION_STATUS_REQUEST,
  UPDATE_KIT_VERSION_STATUS_SUCCESS,
  UPDATE_KIT_VERSION_STATUS_FAIL,
  DELETE_KIT_VERSION_REQUEST,
  DELETE_KIT_VERSION_SUCCESS,
  DELETE_KIT_VERSION_FAIL,
  LIST_NORMAL_VALUE_REQUEST,
  LIST_NORMAL_VALUE_SUCCESS,
  LIST_NORMAL_VALUE_FAIL,
  DELETE_NORMAL_VALUE_REQUEST,
  DELETE_NORMAL_VALUE_SUCCESS,
  DELETE_NORMAL_VALUE_FAIL,
  DETAIL_NORMAL_VALUE_REQUEST,
  DETAIL_NORMAL_VALUE_SUCCESS,
  DETAIL_NORMAL_VALUE_FAIL,
  DETAIL_NORMAL_VALUE_PRINTED_REQUEST,
  DETAIL_NORMAL_VALUE_PRINTED_SUCCESS,
  DETAIL_NORMAL_VALUE_PRINTED_FAIL,
  CREATE_NORMAL_VALUE_REQUEST,
  CREATE_NORMAL_VALUE_SUCCESS,
  CREATE_NORMAL_VALUE_FAIL,
  UPDATE_NORMAL_VALUE_REQUEST,
  UPDATE_NORMAL_VALUE_SUCCESS,
  UPDATE_NORMAL_VALUE_FAIL,
  EXPORT_EXAMINATION_ITEM_REQUEST,
  EXPORT_EXAMINATION_ITEM_SUCCESS,
  EXPORT_EXAMINATION_ITEM_FAIL
} from '../../constants/examination-items'

const initialState = {
  examinationItems: [],
  examinationItem: {},
  examinationItemSummary: [],
  kitVersions: [],
  kitVersion: {},
  normalPrinted: {},
  loading: false,
  loadingDetail: false,
  loadingPosition: false,
  loadingExport: false,
  error: null
}

const examinationItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXAMINATION_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
        examinationItems: []
      }
    case LIST_EXAMINATION_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        examinationItems: action.payload
      }
    case LIST_EXAMINATION_ITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_EXAMINATION_ITEM_RESET:
      return initialState
    case SUMMARY_EXAMINATION_ITEM_REQUEST:
      return { ...state, loadingSummary: true }
    case SUMMARY_EXAMINATION_ITEM_SUCCESS:
      const newState = {
        ...state,
        loadingSummary: false,
        examinationItemSummary: action.payload
      }
      if (!action.onlySummary) {
        newState.examinationItems = action.payload
      }
      return newState
    case SUMMARY_EXAMINATION_ITEM_FAIL:
      return { ...state, loadingSummary: false, error: action.payload }
    case POSITION_EXAMINATION_ITEM_REQUEST:
      return { ...state, loadingPosition: true }
    case POSITION_EXAMINATION_ITEM_SUCCESS:
      return { ...state, loadingPosition: false }
    case POSITION_EXAMINATION_ITEM_FAIL:
      return { ...state, loadingPosition: false, error: action.payload }
    case CREATE_EXAMINATION_ITEM_REQUEST:
      return { ...state, loadingUpdate: true }
    case CREATE_EXAMINATION_ITEM_SUCCESS:
      return { ...state, loadingUpdate: false }
    case CREATE_EXAMINATION_ITEM_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DETAIL_EXAMINATION_ITEM_REQUEST:
      return { ...state, loading: true, examinationItem: {} }
    case DETAIL_EXAMINATION_ITEM_SUCCESS:
      return { ...state, loading: false, examinationItem: action?.payload }
    case DETAIL_EXAMINATION_ITEM_FAIL:
      return { ...state, loading: false, error: action.payload }
    case UPDATE_EXAMINATION_ITEM_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_EXAMINATION_ITEM_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_EXAMINATION_ITEM_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_EXAMINATION_ITEM_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_EXAMINATION_ITEM_SUCCESS:
      const examinationId = action.payload

      const examinationIndexDelete = state.examinationItems.findIndex(
        (examination) => examination.id === examinationId
      )
      const examinationsDelete = [...state.examinationItems]

      examinationsDelete.splice(examinationIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        examinationItems: examinationsDelete
      }
    case DELETE_EXAMINATION_ITEM_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case LIST_KIT_VERSION_REQUEST:
      return {
        ...state,
        loading: true,
        kitVersions: []
      }
    case LIST_KIT_VERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        kitVersions: action.payload
      }
    case LIST_KIT_VERSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_KIT_VERSION_REQUEST:
      return { ...state, loading: true }
    case CREATE_KIT_VERSION_SUCCESS:
      return { ...state, loading: false }
    case CREATE_KIT_VERSION_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_KIT_VERSION_REQUEST:
      return { ...state, loadingDetail: true, kitVersion: null }
    case DETAIL_KIT_VERSION_SUCCESS:
      return { ...state, loadingDetail: false, kitVersion: action?.payload }
    case DETAIL_KIT_VERSION_FAIL:
      return { ...state, loadingDetail: false, error: action.payload, kitVersion: null }
    case UPDATE_KIT_VERSION_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_KIT_VERSION_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_KIT_VERSION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case UPDATE_KIT_VERSION_STATUS_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_KIT_VERSION_STATUS_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_KIT_VERSION_STATUS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_KIT_VERSION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_KIT_VERSION_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_KIT_VERSION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case LIST_NORMAL_VALUE_REQUEST:
      return {
        ...state,
        loading: true,
        kitVersions: []
      }
    case LIST_NORMAL_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        kitVersions: action.payload
      }
    case LIST_NORMAL_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DELETE_NORMAL_VALUE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_NORMAL_VALUE_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_NORMAL_VALUE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case CREATE_NORMAL_VALUE_REQUEST:
      return { ...state, loading: true }
    case CREATE_NORMAL_VALUE_SUCCESS:
      return { ...state, loading: false }
    case CREATE_NORMAL_VALUE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case UPDATE_NORMAL_VALUE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_NORMAL_VALUE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_NORMAL_VALUE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DETAIL_NORMAL_VALUE_REQUEST:
      return { ...state, loadingUpdate: true, kitVersion: {} }
    case DETAIL_NORMAL_VALUE_SUCCESS:
      return { ...state, loadingUpdate: false, kitVersion: action?.payload }
    case DETAIL_NORMAL_VALUE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DETAIL_NORMAL_VALUE_PRINTED_REQUEST:
      return { ...state, loadingUpdate: true, normalPrinted: {} }
    case DETAIL_NORMAL_VALUE_PRINTED_SUCCESS:
      return { ...state, loadingUpdate: false, normalPrinted: action?.payload }
    case DETAIL_NORMAL_VALUE_PRINTED_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
      case EXPORT_EXAMINATION_ITEM_REQUEST:
        return { ...state, loadingExport: true }
      case EXPORT_EXAMINATION_ITEM_SUCCESS:
        return { ...state, loadingExport: false }
      case EXPORT_EXAMINATION_ITEM_FAIL:
        return { ...state, loadingExport: false }
    default:
      return state
  }
}

export default examinationItemReducer
